import { memo } from 'react';
import Box from '@mui/material/Box';
// Local files
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import ConfirmFlow from 'components/Flows/ConfirmFlows/ConfirmFlows';
import ConfirmAnalysisDrawer from 'components/Analyses/ConfirmAnalyses/Drawer/Drawer';

const ConfirmFlows = () => {

  return (
    <Box sx={{ flexGrow: 1, display: 'flex', overflow: 'hidden'  }}>
      <ConfirmAnalysisDrawer />
      <ConfirmFlow />
    </Box>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <ConfirmFlows {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);